import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAttachment = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.25,9.9l-10.977,10.978l4.64669e-07,-4.64669e-07c-2.63605,2.63606 -6.90994,2.63606 -9.546,9.29337e-07c-2.63606,-2.63605 -2.63606,-6.90994 -9.29337e-07,-9.546l9.016,-9.015l1.36283e-07,-1.41104e-07c1.72655,-1.78763 4.57537,-1.83715 6.363,-0.110594c1.78763,1.72655 1.83715,4.57537 0.110594,6.363c-0.0362194,0.0375007 -0.0730877,0.0743691 -0.110588,0.110588l-9.01501,9.02001l6.12874e-08,-5.9212e-08c-0.89368,0.863418 -2.31809,0.838886 -3.18151,-0.0547945c-0.842274,-0.871795 -0.842491,-2.25415 -0.000491428,-3.12621l9.016,-9.019",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round"
	})
});
export default SvgAttachment;
